// List of common country codes for phone numbers
export const COUNTRY_CODES = [
  { value: '+1', label: 'United States (+1)', country: 'US', flag: '🇺🇸' },
  { value: '+1', label: 'Canada (+1)', country: 'CA', flag: '🇨🇦' },
  { value: '+44', label: 'United Kingdom (+44)', country: 'GB', flag: '🇬🇧' },
  { value: '+91', label: 'India (+91)', country: 'IN', flag: '🇮🇳' },
  { value: '+86', label: 'China (+86)', country: 'CN', flag: '🇨🇳' },
  { value: '+49', label: 'Germany (+49)', country: 'DE', flag: '🇩🇪' },
  { value: '+33', label: 'France (+33)', country: 'FR', flag: '🇫🇷' },
  { value: '+81', label: 'Japan (+81)', country: 'JP', flag: '🇯🇵' },
  { value: '+82', label: 'South Korea (+82)', country: 'KR', flag: '🇰🇷' },
  { value: '+61', label: 'Australia (+61)', country: 'AU', flag: '🇦🇺' },
  { value: '+55', label: 'Brazil (+55)', country: 'BR', flag: '🇧🇷' },
  { value: '+52', label: 'Mexico (+52)', country: 'MX', flag: '🇲🇽' },
  { value: '+34', label: 'Spain (+34)', country: 'ES', flag: '🇪🇸' },
  { value: '+39', label: 'Italy (+39)', country: 'IT', flag: '🇮🇹' },
  { value: '+31', label: 'Netherlands (+31)', country: 'NL', flag: '🇳🇱' },
  { value: '+7', label: 'Russia (+7)', country: 'RU', flag: '🇷🇺' },
  { value: '+46', label: 'Sweden (+46)', country: 'SE', flag: '🇸🇪' },
  { value: '+47', label: 'Norway (+47)', country: 'NO', flag: '🇳🇴' },
  { value: '+45', label: 'Denmark (+45)', country: 'DK', flag: '🇩🇰' },
  { value: '+41', label: 'Switzerland (+41)', country: 'CH', flag: '🇨🇭' },
  { value: '+43', label: 'Austria (+43)', country: 'AT', flag: '🇦🇹' },
  { value: '+32', label: 'Belgium (+32)', country: 'BE', flag: '🇧🇪' },
  { value: '+351', label: 'Portugal (+351)', country: 'PT', flag: '🇵🇹' },
  { value: '+48', label: 'Poland (+48)', country: 'PL', flag: '🇵🇱' },
  { value: '+420', label: 'Czech Republic (+420)', country: 'CZ', flag: '🇨🇿' },
  { value: '+36', label: 'Hungary (+36)', country: 'HU', flag: '🇭🇺' },
  { value: '+30', label: 'Greece (+30)', country: 'GR', flag: '🇬🇷' },
  { value: '+90', label: 'Turkey (+90)', country: 'TR', flag: '🇹🇷' },
  { value: '+972', label: 'Israel (+972)', country: 'IL', flag: '🇮🇱' },
  { value: '+971', label: 'UAE (+971)', country: 'AE', flag: '🇦🇪' },
  { value: '+966', label: 'Saudi Arabia (+966)', country: 'SA', flag: '🇸🇦' },
  { value: '+27', label: 'South Africa (+27)', country: 'ZA', flag: '🇿🇦' },
  { value: '+234', label: 'Nigeria (+234)', country: 'NG', flag: '🇳🇬' },
  { value: '+20', label: 'Egypt (+20)', country: 'EG', flag: '🇪🇬' },
  { value: '+65', label: 'Singapore (+65)', country: 'SG', flag: '🇸🇬' },
  { value: '+60', label: 'Malaysia (+60)', country: 'MY', flag: '🇲🇾' },
  { value: '+66', label: 'Thailand (+66)', country: 'TH', flag: '🇹🇭' },
  { value: '+84', label: 'Vietnam (+84)', country: 'VN', flag: '🇻🇳' },
  { value: '+63', label: 'Philippines (+63)', country: 'PH', flag: '🇵🇭' },
  { value: '+62', label: 'Indonesia (+62)', country: 'ID', flag: '🇮🇩' },
  { value: '+64', label: 'New Zealand (+64)', country: 'NZ', flag: '🇳🇿' },
  { value: '+54', label: 'Argentina (+54)', country: 'AR', flag: '🇦🇷' },
  { value: '+56', label: 'Chile (+56)', country: 'CL', flag: '🇨🇱' },
  { value: '+57', label: 'Colombia (+57)', country: 'CO', flag: '🇨🇴' },
  { value: '+51', label: 'Peru (+51)', country: 'PE', flag: '🇵🇪' },
  { value: '+58', label: 'Venezuela (+58)', country: 'VE', flag: '🇻🇪' }
];

// Default country code (US)
export const DEFAULT_COUNTRY_CODE = '+1';
